import { render, staticRenderFns } from "./AccountingDashboardView.vue?vue&type=template&id=4f778970&scoped=true"
import script from "./AccountingDashboardView.vue?vue&type=script&lang=js"
export * from "./AccountingDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f778970",
  null
  
)

export default component.exports